/*
 * Copyright (c) 2016-present, Parse, LLC
 * All rights reserved.
 *
 * This source code is licensed under the license found in the LICENSE file in
 * the root directory of this source tree.
 */
import * as DateUtils from 'lib/DateUtils';
import ParseApp       from 'lib/ParseApp';
import React          from 'react';
import PropTypes from 'prop-types';
import styles         from 'components/PushPreview/PushPreview.scss';

export default class VisiblePreview extends React.Component {
  constructor() {
    super();
  }

  render() {
    let type    = this.props.type;
    let message = this.props.message;
    let time    = this.props.time;
    let appName = this.props.appName;
    let isLocal = this.props.isLocal;

    let classes = [styles.device];
    classes.push(styles[type]);

    let timeStringHours = time[DateUtils.getDateMethod(isLocal, 'getHours')]();
    let timeStringMinutes = time.getUTCMinutes() < 10 ? '0' : '';
    timeStringMinutes += time[DateUtils.getDateMethod(isLocal, 'getMinutes')]();;
    let timeString = <div>{timeStringHours}<span className={styles.dots}>&nbsp;</span>{timeStringMinutes}</div>

    let dateString = DateUtils.WEEKDAYS[time[DateUtils.getDateMethod(isLocal, 'getDay')]()] + ', ' + DateUtils.MONTHS[time[DateUtils.getDateMethod(isLocal, 'getMonth')]()] + ' ' + time[DateUtils.getDateMethod(isLocal, 'getDate')]();
    let notificationTime = null;

    if (type === 'osx') {
      classes.push(styles['macbook']);
    }

    if (type === 'android') {
      classes.push(styles['htc-one']);

      notificationTime = <div className={styles.notifTime}>{timeStringHours + ':' + timeStringMinutes}</div>;
    }

    if (type === 'ios') {
      classes.push(styles['iphone6']);
      classes.push(styles['silver']);

      notificationTime = <div className={styles.notifTime}>{DateUtils.WEEKDAYS[time[DateUtils.getDateMethod(isLocal, 'getDay')]()].substr(0, 3) + ' ' + timeStringHours + ':' + timeStringMinutes}</div>;
    }

    if (type === 'winrt') {
      classes.push(styles['lumia920']);
      classes.push(styles['blue']);

      timeString = timeStringHours + ':' + timeStringMinutes
    }

    return (
      <div className={[styles['preview-' + type]]}>
        <div className={classes.join(' ')}>
          <div className={styles.topBar}></div>
          <div className={styles.sleep}></div>
          <div className={styles.volume}></div>
          <div className={styles.camera}></div>
          <div className={styles.sensor}></div>
          <div className={styles.speaker}></div>
          <div className={styles.screen}>

            <div className={styles.slideOptions}></div>

            <div className={styles.time}>{timeString}</div>
            <div className={styles.date}>{dateString}</div>
            <div className={styles.messageBox}>
              <div className={styles.appIcon}>
                <img src={this.context.currentApp.icon ? this.context.currentApp.icon : '/assets/images/default_app_icon.png' } />
              </div>
              <div className={styles.appName}>{appName}{notificationTime}</div>
              <div className={styles.message}>{message}</div>
              <div className={styles.slideMessage}>slide to view</div>
            </div>

            <div className={styles.slideOptions}></div>

          </div>
          <div className={styles.home}></div>
          <div className={styles.bottomBar}></div>
        </div>
      </div>
    );
  }
}

VisiblePreview.contextTypes = {
  currentApp: PropTypes.instanceOf(ParseApp)
};